(function () {
  'use strict';

  function parseProduct(sectionId) {
    var node = document.getElementById('ProductJson-' + sectionId);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function selectedOptions(section, product) {
    return product.options.map(function (_, index) {
      var selector = '.single-option-selector-' + section.dataset.sectionId + '[data-index="option' + (index + 1) + '"]';
      var input = section.querySelector(selector + ':checked') || section.querySelector(selector);
      return input ? input.value : null;
    });
  }

  function findSelectedVariant(section, product) {
    var values = selectedOptions(section, product);
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) { return value === values[index]; });
    }) || null;
  }

  function markOptionAvailability(section, product) {
    var values = selectedOptions(section, product);
    var selectors = section.querySelectorAll('.single-option-selector-' + section.dataset.sectionId);

    selectors.forEach(function (selector) {
      var optionIndex = parseInt((selector.dataset.index || '').replace('option', ''), 10) - 1;
      if (optionIndex < 0) return;
      var candidates = selector.tagName === 'SELECT' ? Array.prototype.slice.call(selector.options) : [selector];

      candidates.forEach(function (candidate) {
        var isAvailable = product.variants.some(function (variant) {
          if (!variant.available || variant.options[optionIndex] !== candidate.value) return false;
          return variant.options.every(function (value, index) {
            return index === optionIndex || !values[index] || value === values[index];
          });
        });
        var visual = candidate;
        if (candidate.tagName !== 'OPTION') {
          visual = section.querySelector('label[for="' + CSS.escape(candidate.id) + '"]');
        }
        if (visual) visual.classList.toggle('mm-variant-sold-out', !isAvailable);
        candidate.setAttribute('data-sold-out', isAvailable ? 'false' : 'true');
      });
    });
  }

  function ensureTrigger(section, form, addButton) {
    var wrapper = section.querySelector('.js-contact-soldout');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'js-contact-soldout hide';
      form.insertAdjacentElement('afterend', wrapper);
    }
    var trigger = wrapper.querySelector('[data-back-in-stock-trigger], .btn-waitlist');
    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'btn btn-theme back-in-stock-trigger';
      wrapper.appendChild(trigger);
    }
    trigger.setAttribute('data-back-in-stock-trigger', '');
    trigger.setAttribute('data-toggle', 'modal');
    trigger.setAttribute('data-target', '#jsSoldout');
    trigger.textContent = 'Get Notified';
    return { wrapper: wrapper, addButton: addButton };
  }

  function fillModal(product, variant) {
    var modal = document.getElementById('jsSoldout');
    if (!modal || !variant) return;
    var selection = modal.querySelector('[data-back-in-stock-selection]');
    var productId = modal.querySelector('[data-back-in-stock-product-id]');
    var variantId = modal.querySelector('[data-back-in-stock-variant-id]');
    var productTitle = modal.querySelector('[data-back-in-stock-product-title]');
    var variantTitle = modal.querySelector('[data-back-in-stock-variant-title]');
    var note = modal.querySelector('[data-back-in-stock-note]');
    var url = modal.querySelector('[data-back-in-stock-url]');
    var detail = product.title + ' - ' + variant.title;

    if (selection) selection.textContent = detail;
    if (productId) productId.value = product.id;
    if (variantId) variantId.value = variant.id;
    if (productTitle) productTitle.value = product.title;
    if (variantTitle) variantTitle.value = variant.title;
    if (url) url.value = window.location.origin + product.url + '?variant=' + variant.id;
    if (note) note.value = 'Get notified request | Product: ' + product.title + ' | Product ID: ' + product.id + ' | Variant: ' + variant.title + ' | Variant ID: ' + variant.id;
  }

  function initSection(section) {
    var sectionId = section.dataset.sectionId;
    var product = parseProduct(sectionId);
    var form = document.getElementById('AddToCartForm-' + sectionId);
    var addButton = document.getElementById('AddToCart-' + sectionId);
    if (!product || !form || !addButton) return;
    var controls = ensureTrigger(section, form, addButton);

    function update(variant) {
      variant = variant || findSelectedVariant(section, product);
      var soldOut = !!variant && !variant.available;
      controls.wrapper.classList.toggle('hide', !soldOut);
      var submitWrapper = controls.addButton.closest('.product-form__item--submit');
      if (submitWrapper) submitWrapper.classList.toggle('mm-add-to-cart-hidden', soldOut);
      fillModal(product, variant);
      markOptionAvailability(section, product);
    }

    section.addEventListener('change', function () {
      window.setTimeout(function () { update(); }, 0);
    });
    if (window.jQuery) {
      window.jQuery(section).on('variantChange.backInStock', function (event) { update(event.variant); });
    }
    update(findSelectedVariant(section, product));
  }

  function openSuccessModal() {
    var success = document.querySelector('[data-back-in-stock-success]');
    if (success && window.jQuery) window.jQuery('#jsSoldout').modal('show');
  }

  function submissionApiUrl() {
    var queryUrl = new URLSearchParams(window.location.search).get('back_in_stock_api');
    return queryUrl || window.MM_BACK_IN_STOCK_API_URL ||
      'https://script.google.com/macros/s/AKfycbyP_jenDYiveJy4jULRk1hnbL03gYPzGWki44wzsdJoTS_0q-FjfZntgjRuUb5deArKmw/exec';
  }

  function initSubmission() {
    var form = document.getElementById('BackInStockForm');
    if (!form) return;

    form.addEventListener('submit', async function (event) {
      var apiUrl = submissionApiUrl();
      if (!apiUrl) return;
      event.preventDefault();

      var button = form.querySelector('[type="submit"]');
      var errorBox = form.querySelector('[data-back-in-stock-error]');
      if (!errorBox) {
        errorBox = document.createElement('div');
        errorBox.className = 'back-in-stock-form__error';
        errorBox.setAttribute('data-back-in-stock-error', '');
        errorBox.setAttribute('role', 'alert');
        form.insertBefore(errorBox, form.firstChild);
      }
      errorBox.textContent = '';
      button.disabled = true;
      button.textContent = 'Saving...';

      var payload = {
        name: form.querySelector('[name="contact[name]"]').value,
        email: form.querySelector('[name="contact[email]"]').value,
        phone: form.querySelector('[name="contact[phone]"]').value,
        productId: form.querySelector('[data-back-in-stock-product-id]').value,
        variantId: form.querySelector('[data-back-in-stock-variant-id]').value,
        productTitle: form.querySelector('[data-back-in-stock-product-title]').value,
        variantTitle: form.querySelector('[data-back-in-stock-variant-title]').value,
        productUrl: form.querySelector('[data-back-in-stock-url]').value,
      };

      try {
        var isGoogleSheets = apiUrl.indexOf('script.google.com/macros/s/') !== -1;
        var requestOptions = isGoogleSheets ? {
          method: 'POST',
          mode: 'no-cors',
          body: new URLSearchParams(payload),
        } : {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        };
        var response = await fetch(apiUrl, requestOptions);
        if (!isGoogleSheets) {
          var result = await response.json();
          if (!response.ok || !result.ok) throw new Error(result.error || 'Unable to save your request.');
        }
        form.innerHTML = '<div class="back-in-stock-form__success" role="status">Thank you! Your request has been saved.</div>';
      } catch (error) {
        errorBox.textContent = error.message || 'Unable to save your request. Please try again.';
        button.disabled = false;
        button.textContent = 'Notify me';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="product"]').forEach(initSection);
    initSubmission();
    openSuccessModal();
  });
})();
